import { Root } from "./parts/Root";
import { Board } from "./parts/Board";
import { Sounds } from "./parts/Sounds";
import { KeyboardControls } from "./parts/KeyboardControls";

export const ChessGame = {
  Root,
  Board,
  Sounds,
  KeyboardControls,
};
